import { style } from '@vanilla-extract/css';

export const dividerElement = style({
  position: 'relative',
  boxSizing: 'border-box',
  width: 'var(--width)',
  maxWidth: 'var(--max-width)',
  margin: 'var(--margin)',
  padding: 'var(--padding)',
  '@media': {
    'only screen and (max-width: 768px)': {
      width: 'var(--mobile-width)',
      maxWidth: 'var(--mobile-max-width)',
    },
  },
});

export const hr = style({
  border: 'none',
  backgroundColor: 'var(--background-color) !important',
  height: 'var(--height)',
  borderRadius: 'var(--border-radius)',
});
